// extracted by mini-css-extract-plugin
export var modalFooter = "_ta-0";